export enum Lang {
  RU = 'ru',
  EN = 'en',
}

export const SUPPORTED_LANGUAGES = [Lang.RU, Lang.EN] as const;
